// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, Client, TDataShape } from './client';
import type { AuthLoginData, AuthLoginResponses, AuthLoginErrors, AuthLoginGoogleData, AuthLoginGoogleResponses, AuthLoginGoogleErrors, AuthGetCurrentUserData, AuthGetCurrentUserResponses, AuthGetCurrentUserErrors, AuthGetUserProfileData, AuthGetUserProfileResponses, AuthGetUserProfileErrors, AuthLinkGoogleData, AuthLinkGoogleResponses, AuthLinkGoogleErrors, AuthSetEmailData, AuthSetEmailResponses, AuthSetEmailErrors, AuthDismissEmailPromptData, AuthDismissEmailPromptResponses, AuthDismissEmailPromptErrors, UpdateUserSettingsData, UpdateUserSettingsResponses, UpdateUserSettingsErrors, UpdateUserVerificationData, UpdateUserVerificationResponses, UpdateUserVerificationErrors, RequestProfilePictureUploadData, RequestProfilePictureUploadResponses, RequestProfilePictureUploadErrors, ConfirmProfilePictureUploadData, ConfirmProfilePictureUploadResponses, ConfirmProfilePictureUploadErrors, DeleteProfilePictureData, DeleteProfilePictureResponses, DeleteProfilePictureErrors, GetProfilePictureUrlData, GetProfilePictureUrlResponses, GetProfilePictureUrlErrors, ListMatchesData, ListMatchesResponses, ListMatchesErrors, CreateMatchData, CreateMatchResponses, CreateMatchErrors, GetChampionTiersData, GetChampionTiersResponses, GetChampionTiersErrors, GetMatchData, GetMatchResponses, GetMatchErrors, DeleteWikiPageData, DeleteWikiPageResponses, DeleteWikiPageErrors, GetWikiPageByIdData, GetWikiPageByIdResponses, GetWikiPageByIdErrors, UpdateWikiPageData, UpdateWikiPageResponses, UpdateWikiPageErrors, GetAllWikiPagesData, GetAllWikiPagesResponses, GetAllWikiPagesErrors, CreateWikiPageData, CreateWikiPageResponses, CreateWikiPageErrors, PublishWikiPageData, PublishWikiPageResponses, PublishWikiPageErrors, UnpublishWikiPageData, UnpublishWikiPageResponses, UnpublishWikiPageErrors, ListKnowledgePostsData, ListKnowledgePostsResponses, ListKnowledgePostsErrors, CreateKnowledgePostData, CreateKnowledgePostResponses, CreateKnowledgePostErrors, DeleteKnowledgePostData, DeleteKnowledgePostResponses, DeleteKnowledgePostErrors, GetKnowledgePostData, GetKnowledgePostResponses, GetKnowledgePostErrors, UpdateKnowledgePostData, UpdateKnowledgePostResponses, UpdateKnowledgePostErrors, ToggleKnowledgePostLikeData, ToggleKnowledgePostLikeResponses, ToggleKnowledgePostLikeErrors, ToggleSaveKnowledgePostData, ToggleSaveKnowledgePostResponses, ToggleSaveKnowledgePostErrors, GetSavedKnowledgePostsData, GetSavedKnowledgePostsResponses, GetSavedKnowledgePostsErrors, ListMyKnowledgePostsData, ListMyKnowledgePostsResponses, ListMyKnowledgePostsErrors, ListKnowledgeCommentsData, ListKnowledgeCommentsResponses, ListKnowledgeCommentsErrors, CreateKnowledgeCommentData, CreateKnowledgeCommentResponses, CreateKnowledgeCommentErrors, CreateKnowledgeReplyData, CreateKnowledgeReplyResponses, CreateKnowledgeReplyErrors, ListGamePatchesData, ListGamePatchesResponses, ListGamePatchesErrors, DeletePinnedComboData, DeletePinnedComboResponses, DeletePinnedComboErrors, GetPinnedComboData, GetPinnedComboResponses, GetPinnedComboErrors, PinComboData, PinComboResponses, PinComboErrors, ListUserCombosData, ListUserCombosResponses, ListUserCombosErrors, CreateUserComboData, CreateUserComboResponses, CreateUserComboErrors, DeleteUserComboData, DeleteUserComboResponses, DeleteUserComboErrors, GetUserComboData, GetUserComboResponses, GetUserComboErrors, UpdateUserComboData, UpdateUserComboResponses, UpdateUserComboErrors, PromoteComboToPostData, PromoteComboToPostResponses, PromoteComboToPostErrors, CreateShareCodeData, CreateShareCodeResponses, CreateShareCodeErrors, ResolveShareCodeData, ResolveShareCodeResponses, ResolveShareCodeErrors, GetAllPatchNotesData, GetAllPatchNotesResponses, GetAllPatchNotesErrors, GetLatestPatchNoteData, GetLatestPatchNoteResponses, GetLatestPatchNoteErrors, GetUserNotificationsData, GetUserNotificationsResponses, GetUserNotificationsErrors, GetUnreadCountData, GetUnreadCountResponses, GetUnreadCountErrors, MarkNotificationAsReadData, MarkNotificationAsReadResponses, MarkNotificationAsReadErrors, MarkAllNotificationsAsReadData, MarkAllNotificationsAsReadResponses, MarkAllNotificationsAsReadErrors, RequestWikiImageUploadData, RequestWikiImageUploadResponses, RequestWikiImageUploadErrors, GetWikiImageViewUrlData, GetWikiImageViewUrlResponses, GetWikiImageViewUrlErrors, GetAllChampionsData, GetAllChampionsResponses, AdminLoginData, AdminLoginResponses, AdminLoginErrors, AdminGetCurrentUserData, AdminGetCurrentUserResponses, AdminGetCurrentUserErrors, AdminChangePasswordData, AdminChangePasswordResponses, AdminChangePasswordErrors, AdminGetAllAdminsData, AdminGetAllAdminsResponses, AdminGetAllAdminsErrors, AdminCreateAdminData, AdminCreateAdminResponses, AdminCreateAdminErrors, AdminUpdateAdminAccessLevelData, AdminUpdateAdminAccessLevelResponses, AdminUpdateAdminAccessLevelErrors, AdminResetAdminPasswordData, AdminResetAdminPasswordResponses, AdminResetAdminPasswordErrors, AdminDeleteAdminData, AdminDeleteAdminResponses, AdminDeleteAdminErrors, AdminGetOverviewStatsData, AdminGetOverviewStatsResponses, AdminGetOverviewStatsErrors, AdminGetUserGrowthData, AdminGetUserGrowthResponses, AdminGetUserGrowthErrors, AdminGetUserRetentionData, AdminGetUserRetentionResponses, AdminGetUserRetentionErrors, AdminGetMatchVolumeData, AdminGetMatchVolumeResponses, AdminGetMatchVolumeErrors, AdminGetGameModeDistributionData, AdminGetGameModeDistributionResponses, AdminGetGameModeDistributionErrors, AdminGetContentEngagementData, AdminGetContentEngagementResponses, AdminGetContentEngagementErrors, AdminGetComboUsageData, AdminGetComboUsageResponses, AdminGetComboUsageErrors, AdminListGamePatchesData, AdminListGamePatchesResponses, AdminListGamePatchesErrors, AdminCreateGamePatchData, AdminCreateGamePatchResponses, AdminCreateGamePatchErrors, AdminDeleteGamePatchData, AdminDeleteGamePatchResponses, AdminDeleteGamePatchErrors, AdminGetGamePatchData, AdminGetGamePatchResponses, AdminGetGamePatchErrors, AdminUpdateGamePatchData, AdminUpdateGamePatchResponses, AdminUpdateGamePatchErrors, AdminGetOverwolfDauData, AdminGetOverwolfDauResponses, AdminGetOverwolfDauErrors, AdminGetOverwolfInstallsData, AdminGetOverwolfInstallsResponses, AdminGetOverwolfInstallsErrors, AdminGetOverwolfDailyRevenueData, AdminGetOverwolfDailyRevenueResponses, AdminGetOverwolfDailyRevenueErrors, AdminGetOverwolfMtdRevenueData, AdminGetOverwolfMtdRevenueResponses, AdminGetOverwolfMtdRevenueErrors, AdminGetOverwolfMonthlyData, AdminGetOverwolfMonthlyResponses, AdminGetOverwolfMonthlyErrors, AdminGetAllNewsData, AdminGetAllNewsResponses, AdminGetAllNewsErrors, AdminCreateNewsData, AdminCreateNewsResponses, AdminCreateNewsErrors, AdminDeleteNewsData, AdminDeleteNewsResponses, AdminDeleteNewsErrors, AdminGetNewsByIdData, AdminGetNewsByIdResponses, AdminGetNewsByIdErrors, AdminUpdateNewsData, AdminUpdateNewsResponses, AdminUpdateNewsErrors, GetVisibleNewsData, GetVisibleNewsResponses, GetVisibleNewsErrors, GetVisibleNewsByIdData, GetVisibleNewsByIdResponses, GetVisibleNewsByIdErrors, GetActiveGamesData, GetActiveGamesResponses, GetActiveGamesErrors, GetActiveGameByIdData, GetActiveGameByIdResponses, GetActiveGameByIdErrors, AdminGetAllChampionsData, AdminGetAllChampionsResponses, AdminGetAllChampionsErrors, AdminCreateChampionData, AdminCreateChampionResponses, AdminCreateChampionErrors, AdminDeactivateChampionData, AdminDeactivateChampionResponses, AdminDeactivateChampionErrors, AdminGetChampionByIdData, AdminGetChampionByIdResponses, AdminGetChampionByIdErrors, AdminUpdateChampionData, AdminUpdateChampionResponses, AdminUpdateChampionErrors, AdminRequestChampionImageUploadData, AdminRequestChampionImageUploadResponses, AdminRequestChampionImageUploadErrors, AdminGetAllCampaignsData, AdminGetAllCampaignsResponses, AdminGetAllCampaignsErrors, AdminCreateCampaignData, AdminCreateCampaignResponses, AdminCreateCampaignErrors, AdminGetCampaignStatsData, AdminGetCampaignStatsResponses, AdminGetCampaignStatsErrors, AdminGetCampaignTimeSeriesData, AdminGetCampaignTimeSeriesResponses, AdminGetCampaignTimeSeriesErrors, AdminDeleteCampaignData, AdminDeleteCampaignResponses, AdminDeleteCampaignErrors, AdminGetCampaignData, AdminGetCampaignResponses, AdminGetCampaignErrors, AdminUpdateCampaignData, AdminUpdateCampaignResponses, AdminUpdateCampaignErrors, AdminGetCampaignEmailTemplatesData, AdminGetCampaignEmailTemplatesResponses, AdminGetCampaignEmailTemplatesErrors, AdminGetCampaignEmailAudienceData, AdminGetCampaignEmailAudienceResponses, AdminGetCampaignEmailAudienceErrors, AdminSendCampaignEmailData, AdminSendCampaignEmailResponses, AdminSendCampaignEmailErrors, AdminGetCampaignEmailHistoryData, AdminGetCampaignEmailHistoryResponses, AdminGetCampaignEmailHistoryErrors, ResolveCampaignReferralData, ResolveCampaignReferralResponses, ResolveCampaignReferralErrors, AdminGetAllAffiliatesData, AdminGetAllAffiliatesResponses, AdminGetAllAffiliatesErrors, AdminCreateAffiliateData, AdminCreateAffiliateResponses, AdminCreateAffiliateErrors, AdminGetAffiliateEarningsData, AdminGetAffiliateEarningsResponses, AdminGetAffiliateEarningsErrors, AdminDeleteAffiliateData, AdminDeleteAffiliateResponses, AdminDeleteAffiliateErrors, AdminGetAffiliateData, AdminGetAffiliateResponses, AdminGetAffiliateErrors, AdminUpdateAffiliateData, AdminUpdateAffiliateResponses, AdminUpdateAffiliateErrors, GetCounterStateData, GetCounterStateResponses, GetCounterStateErrors, AdminGetCounterData, AdminGetCounterResponses, AdminGetCounterErrors, AdminUpdateCounterData, AdminUpdateCounterResponses, AdminUpdateCounterErrors, AdminGetAllPickemEventsData, AdminGetAllPickemEventsResponses, AdminGetAllPickemEventsErrors, AdminCreatePickemEventData, AdminCreatePickemEventResponses, AdminCreatePickemEventErrors, AdminDeletePickemEventData, AdminDeletePickemEventResponses, AdminDeletePickemEventErrors, AdminGetPickemEventByIdData, AdminGetPickemEventByIdResponses, AdminGetPickemEventByIdErrors, AdminUpdatePickemEventData, AdminUpdatePickemEventResponses, AdminUpdatePickemEventErrors, AdminAddPickemCompetitorData, AdminAddPickemCompetitorResponses, AdminAddPickemCompetitorErrors, AdminRemovePickemCompetitorData, AdminRemovePickemCompetitorResponses, AdminRemovePickemCompetitorErrors, AdminUpdatePickemCompetitorData, AdminUpdatePickemCompetitorResponses, AdminUpdatePickemCompetitorErrors, AdminGeneratePickemBracketData, AdminGeneratePickemBracketResponses, AdminGeneratePickemBracketErrors, AdminUpdateBracketMatchResultData, AdminUpdateBracketMatchResultResponses, AdminUpdateBracketMatchResultErrors, AdminPlaceBracketCompetitorData, AdminPlaceBracketCompetitorResponses, AdminPlaceBracketCompetitorErrors, AdminGetPickemLeaderboardData, AdminGetPickemLeaderboardResponses, AdminGetPickemLeaderboardErrors, AdminRequestPickemImageUploadData, AdminRequestPickemImageUploadResponses, AdminRequestPickemImageUploadErrors, AdminSettlePickemRewardsData, AdminSettlePickemRewardsResponses, AdminSettlePickemRewardsErrors, GetPickemEventsData, GetPickemEventsResponses, GetPickemEventsErrors, GetPickemEventDetailData, GetPickemEventDetailResponses, GetPickemEventDetailErrors, GetPickemLeaderboardData, GetPickemLeaderboardResponses, GetPickemLeaderboardErrors, SubmitPickemPicksData, SubmitPickemPicksResponses, SubmitPickemPicksErrors, GetPickemUserBracketData, GetPickemUserBracketResponses, GetPickemUserBracketErrors, GetPickemUserScoreData, GetPickemUserScoreResponses, GetPickemUserScoreErrors, RequestPickemShareImageUploadData, RequestPickemShareImageUploadResponses, RequestPickemShareImageUploadErrors, GetPickemSharePreviewData, GetPickemSharePreviewResponses, GetPickemSharePreviewErrors, GetPickemShortShareData, GetPickemShortShareResponses, GetPickemShortShareErrors, AdminGetAllRewardsData, AdminGetAllRewardsResponses, AdminGetAllRewardsErrors, AdminCreateRewardData, AdminCreateRewardResponses, AdminCreateRewardErrors, AdminDisableRewardData, AdminDisableRewardResponses, AdminDisableRewardErrors, AdminGetRewardByIdData, AdminGetRewardByIdResponses, AdminGetRewardByIdErrors, AdminUpdateRewardData, AdminUpdateRewardResponses, AdminUpdateRewardErrors, AdminEnableRewardData, AdminEnableRewardResponses, AdminEnableRewardErrors, AdminGetAllRewardBoxesData, AdminGetAllRewardBoxesResponses, AdminGetAllRewardBoxesErrors, AdminCreateRewardBoxData, AdminCreateRewardBoxResponses, AdminCreateRewardBoxErrors, AdminDisableRewardBoxData, AdminDisableRewardBoxResponses, AdminDisableRewardBoxErrors, AdminGetRewardBoxByIdData, AdminGetRewardBoxByIdResponses, AdminGetRewardBoxByIdErrors, AdminUpdateRewardBoxData, AdminUpdateRewardBoxResponses, AdminUpdateRewardBoxErrors, AdminEnableRewardBoxData, AdminEnableRewardBoxResponses, AdminEnableRewardBoxErrors, AdminAddRewardBoxItemData, AdminAddRewardBoxItemResponses, AdminAddRewardBoxItemErrors, AdminRemoveRewardBoxItemData, AdminRemoveRewardBoxItemResponses, AdminRemoveRewardBoxItemErrors, AdminUpdateRewardBoxItemData, AdminUpdateRewardBoxItemResponses, AdminUpdateRewardBoxItemErrors, AdminListUserBalancesData, AdminListUserBalancesResponses, AdminListUserBalancesErrors, AdminGetUserBalanceSummaryData, AdminGetUserBalanceSummaryResponses, AdminGetUserBalanceSummaryErrors, AdminGetUserXpHistoryData, AdminGetUserXpHistoryResponses, AdminGetUserXpHistoryErrors, AdminGetUserTokenHistoryData, AdminGetUserTokenHistoryResponses, AdminGetUserTokenHistoryErrors, AdminCreditUserXpData, AdminCreditUserXpResponses, AdminCreditUserXpErrors, AdminCreditUserTokensData, AdminCreditUserTokensResponses, AdminCreditUserTokensErrors, AdminSpendUserTokensData, AdminSpendUserTokensResponses, AdminSpendUserTokensErrors, GetMyBalanceData, GetMyBalanceResponses, GetMyBalanceErrors, GetMyBadgesData, GetMyBadgesResponses, GetMyBadgesErrors, GetMyBoxesData, GetMyBoxesResponses, GetMyBoxesErrors, OpenMyBoxData, OpenMyBoxResponses, OpenMyBoxErrors, AdminGetAllEarnRulesData, AdminGetAllEarnRulesResponses, AdminGetAllEarnRulesErrors, AdminCreateEarnRuleData, AdminCreateEarnRuleResponses, AdminCreateEarnRuleErrors, AdminGetEarnRuleByIdData, AdminGetEarnRuleByIdResponses, AdminGetEarnRuleByIdErrors, AdminUpdateEarnRuleData, AdminUpdateEarnRuleResponses, AdminUpdateEarnRuleErrors, AdminEnableEarnRuleData, AdminEnableEarnRuleResponses, AdminEnableEarnRuleErrors, AdminDisableEarnRuleData, AdminDisableEarnRuleResponses, AdminDisableEarnRuleErrors, AdminGetBountyRulesData, AdminGetBountyRulesResponses, AdminGetBountyRulesErrors, AdminGetCampaignEarningsData, AdminGetCampaignEarningsResponses, AdminGetCampaignEarningsErrors, AdminUpsertBountyRuleData, AdminUpsertBountyRuleResponses, AdminUpsertBountyRuleErrors, AdminDeleteBountyRuleData, AdminDeleteBountyRuleResponses, AdminDeleteBountyRuleErrors, RecordLoginData, RecordLoginResponses, RecordLoginErrors, GetMyLoginStreakData, GetMyLoginStreakResponses, GetMyLoginStreakErrors, AdminStartgglookupData, AdminStartgglookupResponses, AdminStartgglookupErrors, AdminStartggimportData, AdminStartggimportResponses, AdminStartggimportErrors, AdminStartggsetsData, AdminStartggsetsResponses, AdminStartggsetsErrors, AdminStartgglinkData, AdminStartgglinkResponses, AdminStartgglinkErrors, AdminStartggsyncData, AdminStartggsyncResponses, AdminStartggsyncErrors, AdminStartggmetadataData, AdminStartggmetadataResponses, AdminStartggmetadataErrors, AdminStartggrosterData, AdminStartggrosterResponses, AdminStartggrosterErrors } from './types.gen';
import { client } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const authLogin = <ThrowOnError extends boolean = false>(options?: Options<AuthLoginData, ThrowOnError>) => {
    return (options?.client ?? client).post<AuthLoginResponses, AuthLoginErrors, ThrowOnError>({
        url: '/api/v1/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authLoginGoogle = <ThrowOnError extends boolean = false>(options?: Options<AuthLoginGoogleData, ThrowOnError>) => {
    return (options?.client ?? client).post<AuthLoginGoogleResponses, AuthLoginGoogleErrors, ThrowOnError>({
        url: '/api/v1/auth/login/google',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authGetCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<AuthGetCurrentUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<AuthGetCurrentUserResponses, AuthGetCurrentUserErrors, ThrowOnError>({
        url: '/api/v1/auth/me',
        ...options
    });
};

export const authGetUserProfile = <ThrowOnError extends boolean = false>(options?: Options<AuthGetUserProfileData, ThrowOnError>) => {
    return (options?.client ?? client).get<AuthGetUserProfileResponses, AuthGetUserProfileErrors, ThrowOnError>({
        url: '/api/v1/auth/profile',
        ...options
    });
};

export const authLinkGoogle = <ThrowOnError extends boolean = false>(options?: Options<AuthLinkGoogleData, ThrowOnError>) => {
    return (options?.client ?? client).post<AuthLinkGoogleResponses, AuthLinkGoogleErrors, ThrowOnError>({
        url: '/api/v1/auth/link/google',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authSetEmail = <ThrowOnError extends boolean = false>(options?: Options<AuthSetEmailData, ThrowOnError>) => {
    return (options?.client ?? client).put<AuthSetEmailResponses, AuthSetEmailErrors, ThrowOnError>({
        url: '/api/v1/auth/email',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authDismissEmailPrompt = <ThrowOnError extends boolean = false>(options?: Options<AuthDismissEmailPromptData, ThrowOnError>) => {
    return (options?.client ?? client).post<AuthDismissEmailPromptResponses, AuthDismissEmailPromptErrors, ThrowOnError>({
        url: '/api/v1/auth/email-prompt/dismiss',
        ...options
    });
};

export const updateUserSettings = <ThrowOnError extends boolean = false>(options?: Options<UpdateUserSettingsData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateUserSettingsResponses, UpdateUserSettingsErrors, ThrowOnError>({
        url: '/api/v1/user/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const updateUserVerification = <ThrowOnError extends boolean = false>(options?: Options<UpdateUserVerificationData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateUserVerificationResponses, UpdateUserVerificationErrors, ThrowOnError>({
        url: '/api/v1/user/verification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const requestProfilePictureUpload = <ThrowOnError extends boolean = false>(options?: Options<RequestProfilePictureUploadData, ThrowOnError>) => {
    return (options?.client ?? client).post<RequestProfilePictureUploadResponses, RequestProfilePictureUploadErrors, ThrowOnError>({
        url: '/api/v1/profile-picture/request-upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const confirmProfilePictureUpload = <ThrowOnError extends boolean = false>(options?: Options<ConfirmProfilePictureUploadData, ThrowOnError>) => {
    return (options?.client ?? client).post<ConfirmProfilePictureUploadResponses, ConfirmProfilePictureUploadErrors, ThrowOnError>({
        url: '/api/v1/profile-picture/confirm-upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const deleteProfilePicture = <ThrowOnError extends boolean = false>(options?: Options<DeleteProfilePictureData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteProfilePictureResponses, DeleteProfilePictureErrors, ThrowOnError>({
        url: '/api/v1/profile-picture',
        ...options
    });
};

export const getProfilePictureUrl = <ThrowOnError extends boolean = false>(options: Options<GetProfilePictureUrlData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProfilePictureUrlResponses, GetProfilePictureUrlErrors, ThrowOnError>({
        url: '/api/v1/profile-picture/{s3Key}',
        ...options
    });
};

export const listMatches = <ThrowOnError extends boolean = false>(options?: Options<ListMatchesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListMatchesResponses, ListMatchesErrors, ThrowOnError>({
        url: '/api/v1/matches',
        ...options
    });
};

export const createMatch = <ThrowOnError extends boolean = false>(options?: Options<CreateMatchData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateMatchResponses, CreateMatchErrors, ThrowOnError>({
        url: '/api/v1/matches',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getChampionTiers = <ThrowOnError extends boolean = false>(options?: Options<GetChampionTiersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetChampionTiersResponses, GetChampionTiersErrors, ThrowOnError>({
        url: '/api/v1/matches/tiers',
        ...options
    });
};

export const getMatch = <ThrowOnError extends boolean = false>(options: Options<GetMatchData, ThrowOnError>) => {
    return (options.client ?? client).get<GetMatchResponses, GetMatchErrors, ThrowOnError>({
        url: '/api/v1/matches/{id}',
        ...options
    });
};

export const deleteWikiPage = <ThrowOnError extends boolean = false>(options: Options<DeleteWikiPageData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteWikiPageResponses, DeleteWikiPageErrors, ThrowOnError>({
        url: '/api/v1/wiki/{id}',
        ...options
    });
};

export const getWikiPageById = <ThrowOnError extends boolean = false>(options: Options<GetWikiPageByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWikiPageByIdResponses, GetWikiPageByIdErrors, ThrowOnError>({
        url: '/api/v1/wiki/{id}',
        ...options
    });
};

export const updateWikiPage = <ThrowOnError extends boolean = false>(options: Options<UpdateWikiPageData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateWikiPageResponses, UpdateWikiPageErrors, ThrowOnError>({
        url: '/api/v1/wiki/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getAllWikiPages = <ThrowOnError extends boolean = false>(options?: Options<GetAllWikiPagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllWikiPagesResponses, GetAllWikiPagesErrors, ThrowOnError>({
        url: '/api/v1/wiki',
        ...options
    });
};

export const createWikiPage = <ThrowOnError extends boolean = false>(options?: Options<CreateWikiPageData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateWikiPageResponses, CreateWikiPageErrors, ThrowOnError>({
        url: '/api/v1/wiki',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const publishWikiPage = <ThrowOnError extends boolean = false>(options: Options<PublishWikiPageData, ThrowOnError>) => {
    return (options.client ?? client).patch<PublishWikiPageResponses, PublishWikiPageErrors, ThrowOnError>({
        url: '/api/v1/wiki/{id}/publish',
        ...options
    });
};

export const unpublishWikiPage = <ThrowOnError extends boolean = false>(options: Options<UnpublishWikiPageData, ThrowOnError>) => {
    return (options.client ?? client).patch<UnpublishWikiPageResponses, UnpublishWikiPageErrors, ThrowOnError>({
        url: '/api/v1/wiki/{id}/unpublish',
        ...options
    });
};

export const listKnowledgePosts = <ThrowOnError extends boolean = false>(options?: Options<ListKnowledgePostsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListKnowledgePostsResponses, ListKnowledgePostsErrors, ThrowOnError>({
        url: '/api/v1/community/posts',
        ...options
    });
};

export const createKnowledgePost = <ThrowOnError extends boolean = false>(options?: Options<CreateKnowledgePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateKnowledgePostResponses, CreateKnowledgePostErrors, ThrowOnError>({
        url: '/api/v1/community/posts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const deleteKnowledgePost = <ThrowOnError extends boolean = false>(options: Options<DeleteKnowledgePostData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteKnowledgePostResponses, DeleteKnowledgePostErrors, ThrowOnError>({
        url: '/api/v1/community/posts/{id}',
        ...options
    });
};

export const getKnowledgePost = <ThrowOnError extends boolean = false>(options: Options<GetKnowledgePostData, ThrowOnError>) => {
    return (options.client ?? client).get<GetKnowledgePostResponses, GetKnowledgePostErrors, ThrowOnError>({
        url: '/api/v1/community/posts/{id}',
        ...options
    });
};

export const updateKnowledgePost = <ThrowOnError extends boolean = false>(options: Options<UpdateKnowledgePostData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateKnowledgePostResponses, UpdateKnowledgePostErrors, ThrowOnError>({
        url: '/api/v1/community/posts/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const toggleKnowledgePostLike = <ThrowOnError extends boolean = false>(options: Options<ToggleKnowledgePostLikeData, ThrowOnError>) => {
    return (options.client ?? client).post<ToggleKnowledgePostLikeResponses, ToggleKnowledgePostLikeErrors, ThrowOnError>({
        url: '/api/v1/community/posts/{id}/likes',
        ...options
    });
};

export const toggleSaveKnowledgePost = <ThrowOnError extends boolean = false>(options: Options<ToggleSaveKnowledgePostData, ThrowOnError>) => {
    return (options.client ?? client).post<ToggleSaveKnowledgePostResponses, ToggleSaveKnowledgePostErrors, ThrowOnError>({
        url: '/api/v1/community/posts/{id}/save',
        ...options
    });
};

export const getSavedKnowledgePosts = <ThrowOnError extends boolean = false>(options?: Options<GetSavedKnowledgePostsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSavedKnowledgePostsResponses, GetSavedKnowledgePostsErrors, ThrowOnError>({
        url: '/api/v1/community/saved-posts',
        ...options
    });
};

export const listMyKnowledgePosts = <ThrowOnError extends boolean = false>(options?: Options<ListMyKnowledgePostsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListMyKnowledgePostsResponses, ListMyKnowledgePostsErrors, ThrowOnError>({
        url: '/api/v1/community/my-posts',
        ...options
    });
};

export const listKnowledgeComments = <ThrowOnError extends boolean = false>(options: Options<ListKnowledgeCommentsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListKnowledgeCommentsResponses, ListKnowledgeCommentsErrors, ThrowOnError>({
        url: '/api/v1/community/posts/{id}/comments',
        ...options
    });
};

export const createKnowledgeComment = <ThrowOnError extends boolean = false>(options: Options<CreateKnowledgeCommentData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateKnowledgeCommentResponses, CreateKnowledgeCommentErrors, ThrowOnError>({
        url: '/api/v1/community/posts/{id}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const createKnowledgeReply = <ThrowOnError extends boolean = false>(options: Options<CreateKnowledgeReplyData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateKnowledgeReplyResponses, CreateKnowledgeReplyErrors, ThrowOnError>({
        url: '/api/v1/community/comments/{commentId}/replies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const listGamePatches = <ThrowOnError extends boolean = false>(options?: Options<ListGamePatchesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListGamePatchesResponses, ListGamePatchesErrors, ThrowOnError>({
        url: '/api/v1/community/patches',
        ...options
    });
};

export const deletePinnedCombo = <ThrowOnError extends boolean = false>(options?: Options<DeletePinnedComboData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeletePinnedComboResponses, DeletePinnedComboErrors, ThrowOnError>({
        url: '/api/v1/pinned-combo',
        ...options
    });
};

export const getPinnedCombo = <ThrowOnError extends boolean = false>(options?: Options<GetPinnedComboData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPinnedComboResponses, GetPinnedComboErrors, ThrowOnError>({
        url: '/api/v1/pinned-combo',
        ...options
    });
};

export const pinCombo = <ThrowOnError extends boolean = false>(options?: Options<PinComboData, ThrowOnError>) => {
    return (options?.client ?? client).post<PinComboResponses, PinComboErrors, ThrowOnError>({
        url: '/api/v1/pinned-combo',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const listUserCombos = <ThrowOnError extends boolean = false>(options?: Options<ListUserCombosData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListUserCombosResponses, ListUserCombosErrors, ThrowOnError>({
        url: '/api/v1/combos',
        ...options
    });
};

export const createUserCombo = <ThrowOnError extends boolean = false>(options?: Options<CreateUserComboData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateUserComboResponses, CreateUserComboErrors, ThrowOnError>({
        url: '/api/v1/combos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const deleteUserCombo = <ThrowOnError extends boolean = false>(options: Options<DeleteUserComboData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteUserComboResponses, DeleteUserComboErrors, ThrowOnError>({
        url: '/api/v1/combos/{id}',
        ...options
    });
};

export const getUserCombo = <ThrowOnError extends boolean = false>(options: Options<GetUserComboData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUserComboResponses, GetUserComboErrors, ThrowOnError>({
        url: '/api/v1/combos/{id}',
        ...options
    });
};

export const updateUserCombo = <ThrowOnError extends boolean = false>(options: Options<UpdateUserComboData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateUserComboResponses, UpdateUserComboErrors, ThrowOnError>({
        url: '/api/v1/combos/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const promoteComboToPost = <ThrowOnError extends boolean = false>(options: Options<PromoteComboToPostData, ThrowOnError>) => {
    return (options.client ?? client).post<PromoteComboToPostResponses, PromoteComboToPostErrors, ThrowOnError>({
        url: '/api/v1/combos/{id}/promote-to-post',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const createShareCode = <ThrowOnError extends boolean = false>(options?: Options<CreateShareCodeData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateShareCodeResponses, CreateShareCodeErrors, ThrowOnError>({
        url: '/api/v1/combo-sharing/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const resolveShareCode = <ThrowOnError extends boolean = false>(options: Options<ResolveShareCodeData, ThrowOnError>) => {
    return (options.client ?? client).get<ResolveShareCodeResponses, ResolveShareCodeErrors, ThrowOnError>({
        url: '/api/v1/combo-sharing/resolve/{code}',
        ...options
    });
};

export const getAllPatchNotes = <ThrowOnError extends boolean = false>(options?: Options<GetAllPatchNotesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllPatchNotesResponses, GetAllPatchNotesErrors, ThrowOnError>({
        url: '/api/v1/patch-notes',
        ...options
    });
};

export const getLatestPatchNote = <ThrowOnError extends boolean = false>(options?: Options<GetLatestPatchNoteData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetLatestPatchNoteResponses, GetLatestPatchNoteErrors, ThrowOnError>({
        url: '/api/v1/patch-notes/latest',
        ...options
    });
};

export const getUserNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetUserNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserNotificationsResponses, GetUserNotificationsErrors, ThrowOnError>({
        url: '/api/v1/notifications',
        ...options
    });
};

export const getUnreadCount = <ThrowOnError extends boolean = false>(options?: Options<GetUnreadCountData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUnreadCountResponses, GetUnreadCountErrors, ThrowOnError>({
        url: '/api/v1/notifications/unread-count',
        ...options
    });
};

export const markNotificationAsRead = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationAsReadData, ThrowOnError>) => {
    return (options.client ?? client).patch<MarkNotificationAsReadResponses, MarkNotificationAsReadErrors, ThrowOnError>({
        url: '/api/v1/notifications/{id}/read',
        ...options
    });
};

export const markAllNotificationsAsRead = <ThrowOnError extends boolean = false>(options?: Options<MarkAllNotificationsAsReadData, ThrowOnError>) => {
    return (options?.client ?? client).patch<MarkAllNotificationsAsReadResponses, MarkAllNotificationsAsReadErrors, ThrowOnError>({
        url: '/api/v1/notifications/read-all',
        ...options
    });
};

export const requestWikiImageUpload = <ThrowOnError extends boolean = false>(options?: Options<RequestWikiImageUploadData, ThrowOnError>) => {
    return (options?.client ?? client).post<RequestWikiImageUploadResponses, RequestWikiImageUploadErrors, ThrowOnError>({
        url: '/api/v1/wiki-images/request-upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getWikiImageViewUrl = <ThrowOnError extends boolean = false>(options?: Options<GetWikiImageViewUrlData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetWikiImageViewUrlResponses, GetWikiImageViewUrlErrors, ThrowOnError>({
        url: '/api/v1/wiki-images/view-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getAllChampions = <ThrowOnError extends boolean = false>(options?: Options<GetAllChampionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllChampionsResponses, unknown, ThrowOnError>({
        url: '/api/v1/champions',
        ...options
    });
};

export const adminLogin = <ThrowOnError extends boolean = false>(options?: Options<AdminLoginData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminLoginResponses, AdminLoginErrors, ThrowOnError>({
        url: '/api/v1/admin/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminGetCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<AdminGetCurrentUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetCurrentUserResponses, AdminGetCurrentUserErrors, ThrowOnError>({
        url: '/api/v1/admin/me',
        ...options
    });
};

export const adminChangePassword = <ThrowOnError extends boolean = false>(options?: Options<AdminChangePasswordData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminChangePasswordResponses, AdminChangePasswordErrors, ThrowOnError>({
        url: '/api/v1/admin/change-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminGetAllAdmins = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllAdminsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllAdminsResponses, AdminGetAllAdminsErrors, ThrowOnError>({
        url: '/api/v1/admin/accounts',
        ...options
    });
};

export const adminCreateAdmin = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateAdminData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateAdminResponses, AdminCreateAdminErrors, ThrowOnError>({
        url: '/api/v1/admin/accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminUpdateAdminAccessLevel = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateAdminAccessLevelData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateAdminAccessLevelResponses, AdminUpdateAdminAccessLevelErrors, ThrowOnError>({
        url: '/api/v1/admin/accounts/{id}/access-level',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminResetAdminPassword = <ThrowOnError extends boolean = false>(options: Options<AdminResetAdminPasswordData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminResetAdminPasswordResponses, AdminResetAdminPasswordErrors, ThrowOnError>({
        url: '/api/v1/admin/accounts/{id}/password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminDeleteAdmin = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteAdminData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDeleteAdminResponses, AdminDeleteAdminErrors, ThrowOnError>({
        url: '/api/v1/admin/accounts/{id}',
        ...options
    });
};

export const adminGetOverviewStats = <ThrowOnError extends boolean = false>(options?: Options<AdminGetOverviewStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetOverviewStatsResponses, AdminGetOverviewStatsErrors, ThrowOnError>({
        url: '/api/v1/admin/analytics/overview',
        ...options
    });
};

export const adminGetUserGrowth = <ThrowOnError extends boolean = false>(options?: Options<AdminGetUserGrowthData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetUserGrowthResponses, AdminGetUserGrowthErrors, ThrowOnError>({
        url: '/api/v1/admin/analytics/users/growth',
        ...options
    });
};

export const adminGetUserRetention = <ThrowOnError extends boolean = false>(options?: Options<AdminGetUserRetentionData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetUserRetentionResponses, AdminGetUserRetentionErrors, ThrowOnError>({
        url: '/api/v1/admin/analytics/users/retention',
        ...options
    });
};

export const adminGetMatchVolume = <ThrowOnError extends boolean = false>(options?: Options<AdminGetMatchVolumeData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetMatchVolumeResponses, AdminGetMatchVolumeErrors, ThrowOnError>({
        url: '/api/v1/admin/analytics/matches/volume',
        ...options
    });
};

export const adminGetGameModeDistribution = <ThrowOnError extends boolean = false>(options?: Options<AdminGetGameModeDistributionData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetGameModeDistributionResponses, AdminGetGameModeDistributionErrors, ThrowOnError>({
        url: '/api/v1/admin/analytics/matches/game-modes',
        ...options
    });
};

export const adminGetContentEngagement = <ThrowOnError extends boolean = false>(options?: Options<AdminGetContentEngagementData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetContentEngagementResponses, AdminGetContentEngagementErrors, ThrowOnError>({
        url: '/api/v1/admin/analytics/content/engagement',
        ...options
    });
};

export const adminGetComboUsage = <ThrowOnError extends boolean = false>(options?: Options<AdminGetComboUsageData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetComboUsageResponses, AdminGetComboUsageErrors, ThrowOnError>({
        url: '/api/v1/admin/analytics/combos/usage',
        ...options
    });
};

export const adminListGamePatches = <ThrowOnError extends boolean = false>(options?: Options<AdminListGamePatchesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminListGamePatchesResponses, AdminListGamePatchesErrors, ThrowOnError>({
        url: '/api/v1/admin/game-patches',
        ...options
    });
};

export const adminCreateGamePatch = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateGamePatchData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateGamePatchResponses, AdminCreateGamePatchErrors, ThrowOnError>({
        url: '/api/v1/admin/game-patches',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminDeleteGamePatch = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteGamePatchData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDeleteGamePatchResponses, AdminDeleteGamePatchErrors, ThrowOnError>({
        url: '/api/v1/admin/game-patches/{id}',
        ...options
    });
};

export const adminGetGamePatch = <ThrowOnError extends boolean = false>(options: Options<AdminGetGamePatchData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetGamePatchResponses, AdminGetGamePatchErrors, ThrowOnError>({
        url: '/api/v1/admin/game-patches/{id}',
        ...options
    });
};

export const adminUpdateGamePatch = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateGamePatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminUpdateGamePatchResponses, AdminUpdateGamePatchErrors, ThrowOnError>({
        url: '/api/v1/admin/game-patches/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminGetOverwolfDau = <ThrowOnError extends boolean = false>(options?: Options<AdminGetOverwolfDauData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetOverwolfDauResponses, AdminGetOverwolfDauErrors, ThrowOnError>({
        url: '/api/v1/admin/overwolf-stats/dau',
        ...options
    });
};

export const adminGetOverwolfInstalls = <ThrowOnError extends boolean = false>(options?: Options<AdminGetOverwolfInstallsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetOverwolfInstallsResponses, AdminGetOverwolfInstallsErrors, ThrowOnError>({
        url: '/api/v1/admin/overwolf-stats/installs',
        ...options
    });
};

export const adminGetOverwolfDailyRevenue = <ThrowOnError extends boolean = false>(options?: Options<AdminGetOverwolfDailyRevenueData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetOverwolfDailyRevenueResponses, AdminGetOverwolfDailyRevenueErrors, ThrowOnError>({
        url: '/api/v1/admin/overwolf-stats/revenue/daily',
        ...options
    });
};

export const adminGetOverwolfMtdRevenue = <ThrowOnError extends boolean = false>(options?: Options<AdminGetOverwolfMtdRevenueData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetOverwolfMtdRevenueResponses, AdminGetOverwolfMtdRevenueErrors, ThrowOnError>({
        url: '/api/v1/admin/overwolf-stats/revenue/mtd',
        ...options
    });
};

export const adminGetOverwolfMonthly = <ThrowOnError extends boolean = false>(options?: Options<AdminGetOverwolfMonthlyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetOverwolfMonthlyResponses, AdminGetOverwolfMonthlyErrors, ThrowOnError>({
        url: '/api/v1/admin/overwolf-stats/revenue/monthly',
        ...options
    });
};

export const adminGetAllNews = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllNewsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllNewsResponses, AdminGetAllNewsErrors, ThrowOnError>({
        url: '/api/v1/admin/news',
        ...options
    });
};

export const adminCreateNews = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateNewsData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateNewsResponses, AdminCreateNewsErrors, ThrowOnError>({
        url: '/api/v1/admin/news',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminDeleteNews = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteNewsData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDeleteNewsResponses, AdminDeleteNewsErrors, ThrowOnError>({
        url: '/api/v1/admin/news/{id}',
        ...options
    });
};

export const adminGetNewsById = <ThrowOnError extends boolean = false>(options: Options<AdminGetNewsByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetNewsByIdResponses, AdminGetNewsByIdErrors, ThrowOnError>({
        url: '/api/v1/admin/news/{id}',
        ...options
    });
};

export const adminUpdateNews = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateNewsData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateNewsResponses, AdminUpdateNewsErrors, ThrowOnError>({
        url: '/api/v1/admin/news/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getVisibleNews = <ThrowOnError extends boolean = false>(options?: Options<GetVisibleNewsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetVisibleNewsResponses, GetVisibleNewsErrors, ThrowOnError>({
        url: '/api/v1/news',
        ...options
    });
};

export const getVisibleNewsById = <ThrowOnError extends boolean = false>(options: Options<GetVisibleNewsByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetVisibleNewsByIdResponses, GetVisibleNewsByIdErrors, ThrowOnError>({
        url: '/api/v1/news/{id}',
        ...options
    });
};

export const getActiveGames = <ThrowOnError extends boolean = false>(options?: Options<GetActiveGamesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetActiveGamesResponses, GetActiveGamesErrors, ThrowOnError>({
        url: '/api/v1/games',
        ...options
    });
};

export const getActiveGameById = <ThrowOnError extends boolean = false>(options: Options<GetActiveGameByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetActiveGameByIdResponses, GetActiveGameByIdErrors, ThrowOnError>({
        url: '/api/v1/games/{id}',
        ...options
    });
};

export const adminGetAllChampions = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllChampionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllChampionsResponses, AdminGetAllChampionsErrors, ThrowOnError>({
        url: '/api/v1/admin/champions',
        ...options
    });
};

export const adminCreateChampion = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateChampionData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateChampionResponses, AdminCreateChampionErrors, ThrowOnError>({
        url: '/api/v1/admin/champions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminDeactivateChampion = <ThrowOnError extends boolean = false>(options: Options<AdminDeactivateChampionData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDeactivateChampionResponses, AdminDeactivateChampionErrors, ThrowOnError>({
        url: '/api/v1/admin/champions/{id}',
        ...options
    });
};

export const adminGetChampionById = <ThrowOnError extends boolean = false>(options: Options<AdminGetChampionByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetChampionByIdResponses, AdminGetChampionByIdErrors, ThrowOnError>({
        url: '/api/v1/admin/champions/{id}',
        ...options
    });
};

export const adminUpdateChampion = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateChampionData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateChampionResponses, AdminUpdateChampionErrors, ThrowOnError>({
        url: '/api/v1/admin/champions/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminRequestChampionImageUpload = <ThrowOnError extends boolean = false>(options?: Options<AdminRequestChampionImageUploadData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminRequestChampionImageUploadResponses, AdminRequestChampionImageUploadErrors, ThrowOnError>({
        url: '/api/v1/admin/champion-images/request-upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminGetAllCampaigns = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllCampaignsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllCampaignsResponses, AdminGetAllCampaignsErrors, ThrowOnError>({
        url: '/api/v1/admin/campaigns',
        ...options
    });
};

export const adminCreateCampaign = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateCampaignData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateCampaignResponses, AdminCreateCampaignErrors, ThrowOnError>({
        url: '/api/v1/admin/campaigns',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminGetCampaignStats = <ThrowOnError extends boolean = false>(options?: Options<AdminGetCampaignStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetCampaignStatsResponses, AdminGetCampaignStatsErrors, ThrowOnError>({
        url: '/api/v1/admin/campaigns/stats',
        ...options
    });
};

export const adminGetCampaignTimeSeries = <ThrowOnError extends boolean = false>(options: Options<AdminGetCampaignTimeSeriesData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetCampaignTimeSeriesResponses, AdminGetCampaignTimeSeriesErrors, ThrowOnError>({
        url: '/api/v1/admin/campaigns/{id}/stats',
        ...options
    });
};

export const adminDeleteCampaign = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteCampaignData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDeleteCampaignResponses, AdminDeleteCampaignErrors, ThrowOnError>({
        url: '/api/v1/admin/campaigns/{id}',
        ...options
    });
};

export const adminGetCampaign = <ThrowOnError extends boolean = false>(options: Options<AdminGetCampaignData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetCampaignResponses, AdminGetCampaignErrors, ThrowOnError>({
        url: '/api/v1/admin/campaigns/{id}',
        ...options
    });
};

export const adminUpdateCampaign = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateCampaignData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateCampaignResponses, AdminUpdateCampaignErrors, ThrowOnError>({
        url: '/api/v1/admin/campaigns/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminGetCampaignEmailTemplates = <ThrowOnError extends boolean = false>(options?: Options<AdminGetCampaignEmailTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetCampaignEmailTemplatesResponses, AdminGetCampaignEmailTemplatesErrors, ThrowOnError>({
        url: '/api/v1/admin/campaign-emails/templates',
        ...options
    });
};

export const adminGetCampaignEmailAudience = <ThrowOnError extends boolean = false>(options: Options<AdminGetCampaignEmailAudienceData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetCampaignEmailAudienceResponses, AdminGetCampaignEmailAudienceErrors, ThrowOnError>({
        url: '/api/v1/admin/campaign-emails/{campaignId}/audience',
        ...options
    });
};

export const adminSendCampaignEmail = <ThrowOnError extends boolean = false>(options: Options<AdminSendCampaignEmailData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminSendCampaignEmailResponses, AdminSendCampaignEmailErrors, ThrowOnError>({
        url: '/api/v1/admin/campaign-emails/{campaignId}/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminGetCampaignEmailHistory = <ThrowOnError extends boolean = false>(options: Options<AdminGetCampaignEmailHistoryData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetCampaignEmailHistoryResponses, AdminGetCampaignEmailHistoryErrors, ThrowOnError>({
        url: '/api/v1/admin/campaign-emails/{campaignId}/sends',
        ...options
    });
};

export const resolveCampaignReferral = <ThrowOnError extends boolean = false>(options: Options<ResolveCampaignReferralData, ThrowOnError>) => {
    return (options.client ?? client).get<ResolveCampaignReferralResponses, ResolveCampaignReferralErrors, ThrowOnError>({
        url: '/api/v1/campaigns/resolve',
        ...options
    });
};

export const adminGetAllAffiliates = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllAffiliatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllAffiliatesResponses, AdminGetAllAffiliatesErrors, ThrowOnError>({
        url: '/api/v1/admin/affiliates',
        ...options
    });
};

export const adminCreateAffiliate = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateAffiliateData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateAffiliateResponses, AdminCreateAffiliateErrors, ThrowOnError>({
        url: '/api/v1/admin/affiliates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminGetAffiliateEarnings = <ThrowOnError extends boolean = false>(options: Options<AdminGetAffiliateEarningsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetAffiliateEarningsResponses, AdminGetAffiliateEarningsErrors, ThrowOnError>({
        url: '/api/v1/admin/affiliates/{id}/earnings',
        ...options
    });
};

export const adminDeleteAffiliate = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteAffiliateData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDeleteAffiliateResponses, AdminDeleteAffiliateErrors, ThrowOnError>({
        url: '/api/v1/admin/affiliates/{id}',
        ...options
    });
};

export const adminGetAffiliate = <ThrowOnError extends boolean = false>(options: Options<AdminGetAffiliateData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetAffiliateResponses, AdminGetAffiliateErrors, ThrowOnError>({
        url: '/api/v1/admin/affiliates/{id}',
        ...options
    });
};

export const adminUpdateAffiliate = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateAffiliateData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateAffiliateResponses, AdminUpdateAffiliateErrors, ThrowOnError>({
        url: '/api/v1/admin/affiliates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getCounterState = <ThrowOnError extends boolean = false>(options?: Options<GetCounterStateData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCounterStateResponses, GetCounterStateErrors, ThrowOnError>({
        url: '/api/v1/counter',
        ...options
    });
};

export const adminGetCounter = <ThrowOnError extends boolean = false>(options?: Options<AdminGetCounterData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetCounterResponses, AdminGetCounterErrors, ThrowOnError>({
        url: '/api/v1/admin/counter',
        ...options
    });
};

export const adminUpdateCounter = <ThrowOnError extends boolean = false>(options?: Options<AdminUpdateCounterData, ThrowOnError>) => {
    return (options?.client ?? client).put<AdminUpdateCounterResponses, AdminUpdateCounterErrors, ThrowOnError>({
        url: '/api/v1/admin/counter',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminGetAllPickemEvents = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllPickemEventsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllPickemEventsResponses, AdminGetAllPickemEventsErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events',
        ...options
    });
};

export const adminCreatePickemEvent = <ThrowOnError extends boolean = false>(options?: Options<AdminCreatePickemEventData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreatePickemEventResponses, AdminCreatePickemEventErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminDeletePickemEvent = <ThrowOnError extends boolean = false>(options: Options<AdminDeletePickemEventData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDeletePickemEventResponses, AdminDeletePickemEventErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}',
        ...options
    });
};

export const adminGetPickemEventById = <ThrowOnError extends boolean = false>(options: Options<AdminGetPickemEventByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetPickemEventByIdResponses, AdminGetPickemEventByIdErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}',
        ...options
    });
};

export const adminUpdatePickemEvent = <ThrowOnError extends boolean = false>(options: Options<AdminUpdatePickemEventData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdatePickemEventResponses, AdminUpdatePickemEventErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAddPickemCompetitor = <ThrowOnError extends boolean = false>(options: Options<AdminAddPickemCompetitorData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAddPickemCompetitorResponses, AdminAddPickemCompetitorErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}/competitors',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminRemovePickemCompetitor = <ThrowOnError extends boolean = false>(options: Options<AdminRemovePickemCompetitorData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminRemovePickemCompetitorResponses, AdminRemovePickemCompetitorErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}/competitors/{competitorId}',
        ...options
    });
};

export const adminUpdatePickemCompetitor = <ThrowOnError extends boolean = false>(options: Options<AdminUpdatePickemCompetitorData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdatePickemCompetitorResponses, AdminUpdatePickemCompetitorErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}/competitors/{competitorId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminGeneratePickemBracket = <ThrowOnError extends boolean = false>(options: Options<AdminGeneratePickemBracketData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminGeneratePickemBracketResponses, AdminGeneratePickemBracketErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}/generate-bracket',
        ...options
    });
};

export const adminUpdateBracketMatchResult = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateBracketMatchResultData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateBracketMatchResultResponses, AdminUpdateBracketMatchResultErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}/bracket-matches/{matchId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminPlaceBracketCompetitor = <ThrowOnError extends boolean = false>(options: Options<AdminPlaceBracketCompetitorData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminPlaceBracketCompetitorResponses, AdminPlaceBracketCompetitorErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}/bracket-matches/{matchId}/place',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminGetPickemLeaderboard = <ThrowOnError extends boolean = false>(options: Options<AdminGetPickemLeaderboardData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetPickemLeaderboardResponses, AdminGetPickemLeaderboardErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}/leaderboard',
        ...options
    });
};

export const adminRequestPickemImageUpload = <ThrowOnError extends boolean = false>(options?: Options<AdminRequestPickemImageUploadData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminRequestPickemImageUploadResponses, AdminRequestPickemImageUploadErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/images/request-upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminSettlePickemRewards = <ThrowOnError extends boolean = false>(options: Options<AdminSettlePickemRewardsData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminSettlePickemRewardsResponses, AdminSettlePickemRewardsErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/events/{eventId}/settle-rewards',
        ...options
    });
};

export const getPickemEvents = <ThrowOnError extends boolean = false>(options?: Options<GetPickemEventsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPickemEventsResponses, GetPickemEventsErrors, ThrowOnError>({
        url: '/api/v1/pickem/events',
        ...options
    });
};

export const getPickemEventDetail = <ThrowOnError extends boolean = false>(options: Options<GetPickemEventDetailData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPickemEventDetailResponses, GetPickemEventDetailErrors, ThrowOnError>({
        url: '/api/v1/pickem/events/{eventId}',
        ...options
    });
};

export const getPickemLeaderboard = <ThrowOnError extends boolean = false>(options: Options<GetPickemLeaderboardData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPickemLeaderboardResponses, GetPickemLeaderboardErrors, ThrowOnError>({
        url: '/api/v1/pickem/events/{eventId}/leaderboard',
        ...options
    });
};

export const submitPickemPicks = <ThrowOnError extends boolean = false>(options: Options<SubmitPickemPicksData, ThrowOnError>) => {
    return (options.client ?? client).post<SubmitPickemPicksResponses, SubmitPickemPicksErrors, ThrowOnError>({
        url: '/api/v1/pickem/events/{eventId}/picks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getPickemUserBracket = <ThrowOnError extends boolean = false>(options: Options<GetPickemUserBracketData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPickemUserBracketResponses, GetPickemUserBracketErrors, ThrowOnError>({
        url: '/api/v1/pickem/events/{eventId}/my-bracket',
        ...options
    });
};

export const getPickemUserScore = <ThrowOnError extends boolean = false>(options: Options<GetPickemUserScoreData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPickemUserScoreResponses, GetPickemUserScoreErrors, ThrowOnError>({
        url: '/api/v1/pickem/events/{eventId}/my-score',
        ...options
    });
};

export const requestPickemShareImageUpload = <ThrowOnError extends boolean = false>(options: Options<RequestPickemShareImageUploadData, ThrowOnError>) => {
    return (options.client ?? client).post<RequestPickemShareImageUploadResponses, RequestPickemShareImageUploadErrors, ThrowOnError>({
        url: '/api/v1/pickem/events/{eventId}/share-image-upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getPickemSharePreview = <ThrowOnError extends boolean = false>(options: Options<GetPickemSharePreviewData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPickemSharePreviewResponses, GetPickemSharePreviewErrors, ThrowOnError>({
        url: '/api/v1/pickem/events/{eventId}/share',
        ...options
    });
};

export const getPickemShortShare = <ThrowOnError extends boolean = false>(options: Options<GetPickemShortShareData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPickemShortShareResponses, GetPickemShortShareErrors, ThrowOnError>({
        url: '/api/v1/pickem/s/{eventId}/{imgKey}',
        ...options
    });
};

export const adminGetAllRewards = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllRewardsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllRewardsResponses, AdminGetAllRewardsErrors, ThrowOnError>({
        url: '/api/v1/admin/rewards',
        ...options
    });
};

export const adminCreateReward = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateRewardData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateRewardResponses, AdminCreateRewardErrors, ThrowOnError>({
        url: '/api/v1/admin/rewards',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminDisableReward = <ThrowOnError extends boolean = false>(options: Options<AdminDisableRewardData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDisableRewardResponses, AdminDisableRewardErrors, ThrowOnError>({
        url: '/api/v1/admin/rewards/{rewardId}',
        ...options
    });
};

export const adminGetRewardById = <ThrowOnError extends boolean = false>(options: Options<AdminGetRewardByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetRewardByIdResponses, AdminGetRewardByIdErrors, ThrowOnError>({
        url: '/api/v1/admin/rewards/{rewardId}',
        ...options
    });
};

export const adminUpdateReward = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateRewardData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateRewardResponses, AdminUpdateRewardErrors, ThrowOnError>({
        url: '/api/v1/admin/rewards/{rewardId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEnableReward = <ThrowOnError extends boolean = false>(options: Options<AdminEnableRewardData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEnableRewardResponses, AdminEnableRewardErrors, ThrowOnError>({
        url: '/api/v1/admin/rewards/{rewardId}/enable',
        ...options
    });
};

export const adminGetAllRewardBoxes = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllRewardBoxesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllRewardBoxesResponses, AdminGetAllRewardBoxesErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes',
        ...options
    });
};

export const adminCreateRewardBox = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateRewardBoxData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateRewardBoxResponses, AdminCreateRewardBoxErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminDisableRewardBox = <ThrowOnError extends boolean = false>(options: Options<AdminDisableRewardBoxData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDisableRewardBoxResponses, AdminDisableRewardBoxErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes/{boxId}',
        ...options
    });
};

export const adminGetRewardBoxById = <ThrowOnError extends boolean = false>(options: Options<AdminGetRewardBoxByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetRewardBoxByIdResponses, AdminGetRewardBoxByIdErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes/{boxId}',
        ...options
    });
};

export const adminUpdateRewardBox = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateRewardBoxData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateRewardBoxResponses, AdminUpdateRewardBoxErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes/{boxId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEnableRewardBox = <ThrowOnError extends boolean = false>(options: Options<AdminEnableRewardBoxData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEnableRewardBoxResponses, AdminEnableRewardBoxErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes/{boxId}/enable',
        ...options
    });
};

export const adminAddRewardBoxItem = <ThrowOnError extends boolean = false>(options: Options<AdminAddRewardBoxItemData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAddRewardBoxItemResponses, AdminAddRewardBoxItemErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes/{boxId}/items',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminRemoveRewardBoxItem = <ThrowOnError extends boolean = false>(options: Options<AdminRemoveRewardBoxItemData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminRemoveRewardBoxItemResponses, AdminRemoveRewardBoxItemErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes/{boxId}/items/{itemId}',
        ...options
    });
};

export const adminUpdateRewardBoxItem = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateRewardBoxItemData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateRewardBoxItemResponses, AdminUpdateRewardBoxItemErrors, ThrowOnError>({
        url: '/api/v1/admin/reward-boxes/{boxId}/items/{itemId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminListUserBalances = <ThrowOnError extends boolean = false>(options?: Options<AdminListUserBalancesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminListUserBalancesResponses, AdminListUserBalancesErrors, ThrowOnError>({
        url: '/api/v1/admin/user-balances',
        ...options
    });
};

export const adminGetUserBalanceSummary = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserBalanceSummaryData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetUserBalanceSummaryResponses, AdminGetUserBalanceSummaryErrors, ThrowOnError>({
        url: '/api/v1/admin/user-balances/{userId}',
        ...options
    });
};

export const adminGetUserXpHistory = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserXpHistoryData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetUserXpHistoryResponses, AdminGetUserXpHistoryErrors, ThrowOnError>({
        url: '/api/v1/admin/user-balances/{userId}/xp-history',
        ...options
    });
};

export const adminGetUserTokenHistory = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserTokenHistoryData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetUserTokenHistoryResponses, AdminGetUserTokenHistoryErrors, ThrowOnError>({
        url: '/api/v1/admin/user-balances/{userId}/token-history',
        ...options
    });
};

export const adminCreditUserXp = <ThrowOnError extends boolean = false>(options: Options<AdminCreditUserXpData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminCreditUserXpResponses, AdminCreditUserXpErrors, ThrowOnError>({
        url: '/api/v1/admin/user-balances/{userId}/credit-xp',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminCreditUserTokens = <ThrowOnError extends boolean = false>(options: Options<AdminCreditUserTokensData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminCreditUserTokensResponses, AdminCreditUserTokensErrors, ThrowOnError>({
        url: '/api/v1/admin/user-balances/{userId}/credit-tokens',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminSpendUserTokens = <ThrowOnError extends boolean = false>(options: Options<AdminSpendUserTokensData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminSpendUserTokensResponses, AdminSpendUserTokensErrors, ThrowOnError>({
        url: '/api/v1/admin/user-balances/{userId}/spend-tokens',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getMyBalance = <ThrowOnError extends boolean = false>(options?: Options<GetMyBalanceData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMyBalanceResponses, GetMyBalanceErrors, ThrowOnError>({
        url: '/api/v1/user-balances/me',
        ...options
    });
};

export const getMyBadges = <ThrowOnError extends boolean = false>(options?: Options<GetMyBadgesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMyBadgesResponses, GetMyBadgesErrors, ThrowOnError>({
        url: '/api/v1/user-balances/me/badges',
        ...options
    });
};

export const getMyBoxes = <ThrowOnError extends boolean = false>(options?: Options<GetMyBoxesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMyBoxesResponses, GetMyBoxesErrors, ThrowOnError>({
        url: '/api/v1/user-balances/me/boxes',
        ...options
    });
};

export const openMyBox = <ThrowOnError extends boolean = false>(options: Options<OpenMyBoxData, ThrowOnError>) => {
    return (options.client ?? client).post<OpenMyBoxResponses, OpenMyBoxErrors, ThrowOnError>({
        url: '/api/v1/user-balances/me/boxes/{id}/open',
        ...options
    });
};

export const adminGetAllEarnRules = <ThrowOnError extends boolean = false>(options?: Options<AdminGetAllEarnRulesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetAllEarnRulesResponses, AdminGetAllEarnRulesErrors, ThrowOnError>({
        url: '/api/v1/admin/earn-rules',
        ...options
    });
};

export const adminCreateEarnRule = <ThrowOnError extends boolean = false>(options?: Options<AdminCreateEarnRuleData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminCreateEarnRuleResponses, AdminCreateEarnRuleErrors, ThrowOnError>({
        url: '/api/v1/admin/earn-rules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminGetEarnRuleById = <ThrowOnError extends boolean = false>(options: Options<AdminGetEarnRuleByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetEarnRuleByIdResponses, AdminGetEarnRuleByIdErrors, ThrowOnError>({
        url: '/api/v1/admin/earn-rules/{ruleId}',
        ...options
    });
};

export const adminUpdateEarnRule = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateEarnRuleData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUpdateEarnRuleResponses, AdminUpdateEarnRuleErrors, ThrowOnError>({
        url: '/api/v1/admin/earn-rules/{ruleId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEnableEarnRule = <ThrowOnError extends boolean = false>(options: Options<AdminEnableEarnRuleData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEnableEarnRuleResponses, AdminEnableEarnRuleErrors, ThrowOnError>({
        url: '/api/v1/admin/earn-rules/{ruleId}/enable',
        ...options
    });
};

export const adminDisableEarnRule = <ThrowOnError extends boolean = false>(options: Options<AdminDisableEarnRuleData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminDisableEarnRuleResponses, AdminDisableEarnRuleErrors, ThrowOnError>({
        url: '/api/v1/admin/earn-rules/{ruleId}/disable',
        ...options
    });
};

export const adminGetBountyRules = <ThrowOnError extends boolean = false>(options: Options<AdminGetBountyRulesData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetBountyRulesResponses, AdminGetBountyRulesErrors, ThrowOnError>({
        url: '/api/v1/admin/earnings/campaigns/{campaignId}/rules',
        ...options
    });
};

export const adminGetCampaignEarnings = <ThrowOnError extends boolean = false>(options: Options<AdminGetCampaignEarningsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminGetCampaignEarningsResponses, AdminGetCampaignEarningsErrors, ThrowOnError>({
        url: '/api/v1/admin/earnings/campaigns/{campaignId}',
        ...options
    });
};

export const adminUpsertBountyRule = <ThrowOnError extends boolean = false>(options?: Options<AdminUpsertBountyRuleData, ThrowOnError>) => {
    return (options?.client ?? client).put<AdminUpsertBountyRuleResponses, AdminUpsertBountyRuleErrors, ThrowOnError>({
        url: '/api/v1/admin/earnings/rules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminDeleteBountyRule = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteBountyRuleData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDeleteBountyRuleResponses, AdminDeleteBountyRuleErrors, ThrowOnError>({
        url: '/api/v1/admin/earnings/rules/{id}',
        ...options
    });
};

export const recordLogin = <ThrowOnError extends boolean = false>(options?: Options<RecordLoginData, ThrowOnError>) => {
    return (options?.client ?? client).post<RecordLoginResponses, RecordLoginErrors, ThrowOnError>({
        url: '/api/v1/login-streak/record',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getMyLoginStreak = <ThrowOnError extends boolean = false>(options?: Options<GetMyLoginStreakData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMyLoginStreakResponses, GetMyLoginStreakErrors, ThrowOnError>({
        url: '/api/v1/login-streak/me',
        ...options
    });
};

export const adminStartgglookup = <ThrowOnError extends boolean = false>(options: Options<AdminStartgglookupData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminStartgglookupResponses, AdminStartgglookupErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/startgg/lookup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStartggimport = <ThrowOnError extends boolean = false>(options: Options<AdminStartggimportData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminStartggimportResponses, AdminStartggimportErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/startgg/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStartggsets = <ThrowOnError extends boolean = false>(options: Options<AdminStartggsetsData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminStartggsetsResponses, AdminStartggsetsErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/startgg/sets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStartgglink = <ThrowOnError extends boolean = false>(options: Options<AdminStartgglinkData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminStartgglinkResponses, AdminStartgglinkErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/startgg/link',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStartggsync = <ThrowOnError extends boolean = false>(options: Options<AdminStartggsyncData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminStartggsyncResponses, AdminStartggsyncErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/startgg/sync',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStartggmetadata = <ThrowOnError extends boolean = false>(options: Options<AdminStartggmetadataData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminStartggmetadataResponses, AdminStartggmetadataErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/startgg/metadata',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStartggroster = <ThrowOnError extends boolean = false>(options: Options<AdminStartggrosterData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminStartggrosterResponses, AdminStartggrosterErrors, ThrowOnError>({
        url: '/api/v1/admin/pickem/startgg/roster',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
